import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=33dc7a7a&lang=css"
import "./App.vue?vue&type=style&index=1&id=33dc7a7a&lang=css"

const __exports__ = script;

export default __exports__